import { Col, Image, Row, Spinner } from "react-bootstrap";
import DashboardButton from "../DashboardButton";
import BigCard from "./BigCard";
import CustomMapContainer from "../../map/CustomMapContainer";
import { useNavigate } from "react-router-dom";
import { useSessionData } from "../../../sessions/useSessionData";

interface MapCardProps {
  sessionID?: string;
  sensorID?: string;
  showButton?: boolean;
}

export default function MapCard({ sessionID, sensorID, showButton }: MapCardProps) {
  const navigate = useNavigate();
  
  // Use cached session data if sessionID and sensorID are available
  const shouldFetchData = sessionID && sensorID;
  const { 
    coordinates, 
    plotData, 
    sessionDetails, 
    isLoading 
  } = useSessionData({ 
    sessionId: sessionID || '', 
    sensorId: sensorID || '' 
  });

  const sessionName = sessionDetails?.name || "";

  // Don't render anything if required props are missing
  if (!sessionID || !sensorID) {
    return (
      <BigCard
        heading="Map Route"
        content={
          <Row className="w-100 justify-content-center text-center">
            <p>Session data not available</p>
          </Row>
        }
      />
    );
  }

  if (isLoading) {
    return (
      <BigCard
        heading="Map Route"
        content={
          <Row className="w-100 justify-content-center text-center">
            <Spinner variant="light" animation="border" />
          </Row>
        }
      />
    );
  }

  // Handle navigation to the map route page
  const handleViewMap = () => {
    if (sessionID) {
      navigate(`/sessions/${sessionID}/map`, {
        state: {
          coordinates,
          plotData,
          sessionId: sessionID,
          sessionName,
          sensorId: sensorID
        }
      });
    }
  };

  let button = showButton ? (
    <DashboardButton
      text="View"
      onClick={handleViewMap}
    />
  ) : null;
  
  var content = <></>;
  if (
    coordinates === undefined ||
    coordinates === null ||
    coordinates.length === 0
  ) {
    content = (
      <Row className="w-100 justify-content-center text-center">
        <p>No coordinates available</p>
      </Row>
    );
  } else {
    content = <CustomMapContainer points={coordinates} height="20vh" />;
  }

  return (
    <BigCard
      heading="Map Route"
      subheading="Last Recording"
      button={button}
      content={content}
    />
  );
}
